export const name = (data = {}) => ({
  type: 'name',
  props: { ...(data || {}) },
});
